<script module lang="ts">
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';

	export interface ResultOptionProps extends SbBlokData {
		component: 'quiz_single_step_result_option';
		result_asset: SbImage;
		title: string;
		description: string;
		tracking_label: string;
	}
</script>

<script lang="ts">
	import Image from '$lib/storyblok/components/image.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage } from '$lib/storyblok/types';

	interface Props {
		content: ISbStoryData<ResultOptionProps>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	{#if content.result_asset?.filename}
		<div class="mx-auto h-[200px] w-[200px]">
			<Image
				src={content.result_asset.filename}
				alt={content.result_asset.alt}
				title={content.result_asset.title}
				class="h-full w-full object-contain"
				width={400}
				height={400}
			/>
		</div>
	{/if}

	<p class="mt-5 font-rhymes text-[36px]/[112%] tracking-[-.36px] lg:mt-8 lg:text-[36px]/[120%]">
		{content.title}
	</p>

	<p class="mt-3 text-[14px]/[160%] lg:text-[16px]/[150%]">
		{content.description}
	</p>
</div>
